import { render, staticRenderFns } from "./cabinet-requests-list.vue?vue&type=template&id=4671e61a&scoped=true&"
import script from "./cabinet-requests-list.vue?vue&type=script&lang=js&"
export * from "./cabinet-requests-list.vue?vue&type=script&lang=js&"
import style0 from "./cabinet-requests-list.vue?vue&type=style&index=0&id=4671e61a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4671e61a",
  null
  
)

export default component.exports